import React from 'react';
import { useTranslation } from 'react-i18next';

export const Notice: React.FC = () => {
  const { t } = useTranslation('byCard');

  return (
    <>
      {t(
        'You can top up with a rouble card only Your bank will convert to dollars automatically at its own rate'
      )}
    </>
  );
};
